import { useEffect, useState } from "react";
import { CONFIG, OFFICIAL_STATUS } from "@/lib/config";
import { Mono } from "@/components/bits";

const TONE = { LIVE: "bg-[#10B981]", "COMING SOON": "bg-[#55B7FF]", BUILDING: "bg-[#F59E0B]" };

export default function StatusBar() {
    const [items, setItems] = useState(OFFICIAL_STATUS);

    useEffect(() => {
        let alive = true;
        fetch(`${CONFIG.BACKEND || ""}/api/vera/status`)
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => {
                if (alive && d && d.components) setItems(d.components);
            })
            .catch(() => {});
        return () => {
            alive = false;
        };
    }, []);

    return (
        <div className="border-t border-white/10 bg-vera-bg2/70 backdrop-blur" data-testid="network-status-bar">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-3 flex flex-wrap items-center gap-x-8 gap-y-2">
                <Mono className="text-vera-gold shrink-0">VERA NETWORK</Mono>
                {items.map((c) => (
                    <span key={c.name} className="flex items-center gap-2" data-testid={`status-${c.name.toLowerCase().replace(/\s+/g, "-")}`}>
                        <Mono className="text-vera-mut">{c.name}</Mono>
                        <span className={`w-1.5 h-1.5 rounded-full ${TONE[c.status] || "bg-vera-blue"} animate-pulse-soft`} aria-hidden="true" />
                        <Mono className="text-vera-white/80">{c.status}</Mono>
                    </span>
                ))}
            </div>
        </div>
    );
}
